export const IMG_ROOT = 'https://annimon.com/pages/azurlane/icon/';
export const STORAGE_ROOT = 'stub';
